import React from 'react'
import Table from './table'
import { useSelector } from 'react-redux'
import { TableLoader } from '../../../../library/table-loader'

import './style.scss'

const Index = () => {

	const loading = useSelector(state => state.user.fetchLogins.loading)

	return(
		<div className="account-subscription-tab-content-container">
			<Table/>
			{loading ? <TableLoader/>:null}
		</div>
	)
}

export default Index